import { render, staticRenderFns } from "./ProductMobileCard.vue?vue&type=template&id=367f8802&scoped=true&"
import script from "./ProductMobileCard.vue?vue&type=script&lang=js&"
export * from "./ProductMobileCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductMobileCard.vue?vue&type=style&index=0&id=367f8802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367f8802",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VCard,VCardSubtitle,VCardTitle,VChip,VIcon,VImg})
